import React, {Component} from 'react';
import SecureLayout from "./secure";
import GobLogo from '../assets/images/gobmxlogo.svg';
import Notification from './../elements/notification';
import Navigation from "../elements/navigation/navigation";
import UserDropdown from "../elements/user-opts-dropdown";
import ProjectsEditSubnav from "../elements/projects-edit-subnav";

export default function (SecuredComponent, data) {
	class ProjectsEditLayout extends Component {
		render() {
			const {notifications, match, location, session, projects, menu} = this.props;
			return [
				<Navigation
					agencies={{...session.user.agencies}}
					cdms={{...session.user.cdms}}
					items={{...session.user.menu}}
					show={menu.view}
					location={{...location}}
					key={`app-navigation-sidebar`}
				/>,

				<div className="project-content" key="project-website-content">
					<nav className="navbar is-dark secondary-navigation">
						<div className="navbar-menu navbar-item">
							<img src={GobLogo} alt="gob.mx" className="app-gov-logo--image" />
						</div>

						{session.user.version ?
							<div className="navbar-menu navbar-item">
								<h6 className="title is-6 has-text-centered has-text-white">{session.user.version.name}</h6>
							</div>:''}

						<button className="main-nav--close" onClick={() => this.toggleMenu()}>
							{menu.view ? <i className="fa fa-chevron-left" /> : <i className="fa fa-chevron-right" />}
						</button>
						<UserDropdown data={{...session.user.profile}} />
					</nav>

					<ProjectsEditSubnav step={data.subnav} params={match.params} projects={projects}/>

					<section className="app-layout--content">
						{notifications.data.title &&
						<div className="columns is-centered">
							<div className="column is-10-desktop">
								<Notification {...notifications} />
							</div>
						</div>}

						<div className="app-container">
							<SecuredComponent {...this.props} />
						</div>
					</section>
				</div>
			]
		}

		constructor() {
			super();
			this.toggleMenu = this.toggleMenu.bind(this);
		}

		toggleMenu() {
			let { view } = this.props.menu;
			return view === true ? this.props.hideMenu() : this.props.showMenu();
		}
	}

	return SecureLayout(ProjectsEditLayout);
}



// WEBPACK FOOTER //
// ./src/templates/projects.jsx